import React, { useEffect, useState } from "react";
import { Image, Box, Text, Flex, Spacer } from "@chakra-ui/react";
import { SavePlacementButton } from "../../../components/SavePlacementButton";
import { usePlacementData } from "../../../hooks/usePlacementData";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { imageUrl } from "../../../services/urlBuilder";
import noSchoolImg from "../../../images/no-photo.jpg";
import { useFocusStyle } from "../../../hooks/useFocusStyle";
import { useOrganization } from "../../../hooks/useOrganization";
import { useTranslations } from "../../../hooks/useTranslations";
import { useConfig } from "../../../hooks/useConfig";

interface ProfileImageSectionProps {
  placementId: string | undefined;
}

export const ProfileImageSection = ({
  placementId,
}: ProfileImageSectionProps): React.ReactElement | null => {
  const { placement } = usePlacementData(placementId);
  const { ids: savedIds } = useSelector((state: RootState) => state.saved);
  const focusStyle = useFocusStyle({ position: "offset", color: "white" });
  const organization = useOrganization();
  const translate = useTranslations();
  const config = useConfig();

  const [canAddSavedSchool, setCanAddSavedSchool] = useState<boolean>(
    config?.maxNumRankable
      ? config.maxNumRankable > 0 && savedIds.length >= config.maxNumRankable
      : true
  );

  useEffect(() => {
    if (config?.maxNumRankable)
      setCanAddSavedSchool(
        config.maxNumRankable > 0 && savedIds.length >= config.maxNumRankable
      );
  }, [config, savedIds]);

  if (!config) return null;

  const continueButtonText = translate(
    (t) => t.eligibility.welcomeModal.continueButton.label
  );

  return (
    <Box position="relative" height={164}>
      <Image
        src={
          placementId
            ? imageUrl(organization?.path || "", placementId)
            : noSchoolImg
        }
        alt={placement?.name}
        fallbackSrc={noSchoolImg}
        height="100%"
        width="100%"
        objectFit="cover"
      />
      <Box
        position="absolute"
        bottom={0}
        left={0}
        right={0}
        background="rgba(0, 0, 0, 0.6)"
        color="white"
        paddingY={2}
        paddingLeft={6}
        paddingRight={3}
      >
        <Flex align="center" gridGap="3">
          <Box>
            <Text as="span" fontSize="md" fontWeight="bold" letterSpacing="xl">
              {placement?.name}
            </Text>
          </Box>
          <Spacer />
          <SavePlacementButton
            canAddSavedSchool={canAddSavedSchool}
            continueButtonText={continueButtonText}
            placementId={placementId}
            size="sm"
            sx={focusStyle}
          />
        </Flex>
      </Box>
    </Box>
  );
};
